import React from "react";
import { SketchPicker } from "react-color";

// Define custom CSS styles for the smaller size
const smallPickerStyle = {
  width: "100px", // Adjust the width as needed
  boxShadow: "none", // Remove the box shadow if desired
};

class ColorPicker extends React.Component {
  render() {
    const { color, onChange } = this.props;

    return (
      <SketchPicker
        color={color}
        onChange={(selectedColor) => onChange(selectedColor.hex)}
        style={smallPickerStyle}
      />
    );
  }
}

export default ColorPicker;
